module.exports = __webpack_public_path__ + "img/H-45-ER-1000-B.1b10862f.png";